import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const AnimatedBlock = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const MissionSection = () => {
  return (
    <section
      data-testid="mission-section"
      className="py-24 md:py-32 bg-[#F5F0EB]"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
        <AnimatedBlock>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-[#442F23] mb-6">
            Di cosa si tratta?
          </h2>
        </AnimatedBlock>

        <AnimatedBlock delay={0.1}>
          <div className="section-divider mb-12" />
        </AnimatedBlock>

        <AnimatedBlock delay={0.2}>
          <p className="font-body text-base md:text-lg text-[#442F23]/80 leading-relaxed mb-8 italic">
            &Egrave; il luogo in cui la tua Luce torna ad espandersi e il tuo Guerriero di Luce si risveglia.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.3}>
          <p className="font-body text-base md:text-lg text-[#442F23]/75 leading-relaxed mb-8">
            Un <strong>percorso di crescita personale e spirituale</strong> di lungo periodo,
            in cui, accompagnata dalla mia guida, grazie a potenti strumenti di coaching,
            embodiment, pratiche energetiche, meditazioni e una Community affiatata di
            ispirazione a supporto, esplorerai e costruirai il tuo{" "}
            <strong>next level in ogni area della tua vita</strong>.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.4}>
          <p className="font-body text-base md:text-lg text-[#442F23]/75 leading-relaxed mb-8">
            &Egrave; La casa dei Guerrieri di Luce, dove riconoscere, liberare e incarnare la tua{" "}
            <strong>energia vitale</strong>, la tua <strong>autenticit&agrave;</strong> e la
            tua luce pi&ugrave; integra &mdash; incarnando il tuo pieno potere personale.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.5}>
          <p className="font-body text-base md:text-lg text-[#AC8E60] leading-relaxed font-medium">
            &Egrave; il richiamo alla tua missione di vita: un ritorno alla tua vera Essenza.
            A ci&ograve; che sei prima del controllo, del giudizio, della paura, dei condizionamenti.
          </p>
        </AnimatedBlock>
      </div>
    </section>
  );
};

export default MissionSection;
